var map = {
	"./avs-beta.json": 7237,
	"./avs-dev.json": 4606,
	"./avs-preprod.json": 2645,
	"./avs-prod.json": 5366,
	"./avs-sandbox.json": 4490,
	"./avs-sit.json": 769,
	"./avs-staging-montreal.json": 2813,
	"./avs-staging-oregon.json": 9003,
	"./avs-staging-ptpreprod.json": 5181,
	"./avs-staging-qaPP-73.json": 1578,
	"./avs-staging-qapreprod.json": 6079,
	"./avs-staging.json": 9816,
	"./avs-tsqapreprod.json": 7072
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 5651;